/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v27.3.0
 * @link https://www.ag-grid.com/
 * @license MIT
 */
export var DateComponent = {
    propertyName: 'dateComponent',
    cellRenderer: false
};
export var HeaderComponent = {
    propertyName: 'headerComponent',
    cellRenderer: false
};
export var HeaderGroupComponent = {
    propertyName: 'headerGroupComponent',
    cellRenderer: false
};
export var CellRendererComponent = {
    propertyName: 'cellRenderer',
    cellRenderer: true
};
export var CellEditorComponent = {
    propertyName: 'cellEditor',
    cellRenderer: false
};
export var InnerRendererComponent = {
    propertyName: 'innerRenderer',
    cellRenderer: true
};
export var LoadingOverlayComponent = {
    propertyName: 'loadingOverlayComponent',
    cellRenderer: false
};
export var NoRowsOverlayComponent = {
    propertyName: 'noRowsOverlayComponent',
    cellRenderer: false
};
export var TooltipComponent = {
    propertyName: 'tooltipComponent',
    cellRenderer: false
};
export var FilterComponent = {
    propertyName: 'filter',
    cellRenderer: false
};
export var FloatingFilterComponent = {
    propertyName: 'floatingFilterComponent',
    cellRenderer: false
};
export var ToolPanelComponent = {
    propertyName: 'toolPanel',
    cellRenderer: false
};
export var StatusPanelComponent = {
    propertyName: 'statusPanel',
    cellRenderer: false
};
export var FullWidth = {
    propertyName: 'fullWidthCellRenderer',
    cellRenderer: true
};
export var FullWidthLoading = {
    propertyName: 'loadingCellRenderer',
    cellRenderer: true
};
export var FullWidthGroup = {
    propertyName: 'groupRowRenderer',
    cellRenderer: true
};
export var FullWidthDetail = {
    propertyName: 'detailCellRenderer',
    cellRenderer: true
};

//# sourceMappingURL=componentTypes.js.map
